package com.daytimegaming.ourdailyfinances.di

import com.daytimegaming.ourdailyfinances.data.network.ApiClient
import com.daytimegaming.ourdailyfinances.data.network.service.AccountService
import com.daytimegaming.ourdailyfinances.data.network.service.DashboardService
import com.daytimegaming.ourdailyfinances.data.network.service.UserService
import com.daytimegaming.ourdailyfinances.data.network.service.BudgetService
import com.daytimegaming.ourdailyfinances.data.network.service.RealEstateService
import com.daytimegaming.ourdailyfinances.data.network.service.GeoApifyService
import com.daytimegaming.ourdailyfinances.data.network.service.EventStreamService
import org.koin.dsl.module

fun networkModule(enableHttpLogging: Boolean = false) = module {
    single { httpClientEngine() }
    single { ApiClient(get(), get(), get(), enableHttpLogging) }
    single { AccountService(get()) }
    single { DashboardService(get()) }
    single { UserService(get()) }
    single { BudgetService(get()) }
    single { RealEstateService(get()) }
    single { GeoApifyService(get()) }
    single { EventStreamService(get(), get()) }
}
